
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deal/[id]",
      function () {
        return require("private-next-pages/deal/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deal/[id]"])
      });
    }
  